<div class="flex items-center w-full h-full p-10 gap-x-20 inline-snackbar" [class]="data.class" @fadeInOut>
    <div class="mr-auto">{{data.message}}</div>
    <button class="ml-auto button is-sm text-gray" (click)="close()">Dismiss</button>
</div>